import countries from "world-countries";

export const provincesAndTerritories = [
    { label: "Alberta", value: "AB" },
    { label: "British Columbia", value: "BC" },
    { label: "Manitoba", value: "MB" },
    { label: "New Brunswick", value: "NB" },
    { label: "Newfoundland and Labrador", value: "NL" },
    { label: "Northwest Territories", value: "NT" },
    { label: "Nova Scotia", value: "NS" },
    { label: "Nunavut", value: "NU" },
    { label: "Ontario", value: "ON" },
    { label: "Prince Edward Island", value: "PE" },
    { label: "Quebec", value: "QC" },
    { label: "Saskatchewan", value: "SK" },
    { label: "Yukon", value: "YT" },
];

export const formattedCountries = countries.map((country) => ({
    value: country.cca2,
    label: country.name.common,
}));
